var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84147 3.24674V7.24674L10.5081 8.58008M14.5081 7.24674C14.5081 10.9286 11.5234 13.9134 7.84147 13.9134C4.15957 13.9134 1.1748 10.9286 1.1748 7.24674C1.1748 3.56485 4.15957 0.580078 7.84147 0.580078C11.5234 0.580078 14.5081 3.56485 14.5081 7.24674Z",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDate);
export default __webpack_public_path__ + "static/media/time-date.629e04475f7758b6d1dfc10e91406913.svg";
export { ForwardRef as ReactComponent };